import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { customerName, sellerFullName } from '~/models/relationship-summary';
import { formatShortMonthUSDate } from '~/utils/date-formatting';
import { calculateStatus, statusLabelMap } from './ProposalsReport.utils';
export class ProposalReportEntryModel {
    static fromSummary(summary) {
        const entry = {
            status: calculateStatus(summary),
            sentBy: {
                id: summary.seller.id,
                name: sellerFullName(summary) || ''
            },
            sentDate: summary.createdOn,
            companyName: customerName(summary),
            approvalDate: summary.approvedAt,
            agreementName: summary.title
        };
        return new ProposalReportEntryModel(entry);
    }
    status() {
        return this.entry.status;
    }
    statusLabel() {
        return statusLabelMap[this.status()];
    }
    sentByName() {
        return this.entry.sentBy.name;
    }
    sentById() {
        return this.entry.sentBy.id;
    }
    sentDate() {
        return this.entry.sentDate;
    }
    formattedSentDate() {
        return formatShortMonthUSDate(this.sentDate());
    }
    companyName() {
        return this.entry.companyName;
    }
    approvalDate() {
        return this.entry.approvalDate;
    }
    formattedApprovalDate() {
        const approvalDate = this.approvalDate();
        return approvalDate ? formatShortMonthUSDate(approvalDate) : '-';
    }
    agreementName() {
        return this.entry.agreementName;
    }
    constructor(entry){
        _define_property(this, "entry", void 0);
        this.entry = entry;
    }
}
